import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { ArrowRight } from "lucide-react";
const services = [{
  title: "Residential Cleaning",
  description: "Meticulous recurring and deep cleaning services tailored for homeowners and renters who value a pristine living environment.",
  link: "/PureDetailBookingPage"
}, {
  title: "Move-In / Move-Out",
  description: "Comprehensive sanitation for realtors and residents. We ensure every square inch meets professional standards for a seamless transition.",
  link: "/PureDetailBookingPage"
}, {
  title: "Commercial Cleaning",
  description: "Disciplined maintenance for small offices and professional spaces. Sharp, clean environments that foster productivity and clarity.",
  link: "/PureDetailBookingPage"
}, {
  title: "Short-Term Rental",
  description: "High-precision turnover cleaning for hosts. Hotel-grade results delivered with punctuality and checklist-based accuracy.",
  link: "/PureDetailBookingPage"
}];
export default function ServiceDetailsGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="service-details-grid" ref={ref} className={cn("bg-secondary/30 py-24 md:py-32 transition-opacity duration-1000 ease-out", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-6 md:px-12">
        <div className="mb-16 max-w-3xl">
          <h2 className="text-sm font-bold tracking-widest uppercase text-primary mb-4">
            Our Expertise
          </h2>
          <p className="text-4xl md:text-5xl font-bold tracking-tighter text-foreground mb-6 font-sans">
            Precision Cleaning. <br />Professional Results.
          </p>
          <p className="text-xl font-serif italic text-primary/80 border-l-2 border-primary pl-6 py-2">
            "Pure Effort. Pure Pride. Pure Detail."
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-border">
          {services.map((service, i) => <div key={i} data-index={i} className="group relative flex flex-col justify-between border-r border-b border-border bg-background p-10 md:p-16 transition-all duration-300 hover:bg-accent/50 min-h-[350px]">
              <div className="relative z-10">
                <div className="mb-8 flex items-center justify-between">
                  <span className="text-xs font-mono text-muted-foreground">
                    0{i + 1}
                  </span>
                  <ArrowRight className="size-5 text-primary opacity-0 -translate-x-4 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0" />
                </div>
                <h3 className="text-2xl md:text-3xl font-bold tracking-tight text-foreground mb-6 font-sans uppercase">
                  {service.title}
                </h3>
                <p className="text-muted-foreground text-lg leading-relaxed max-w-md">
                  {service.description}
                </p>
              </div>

              <div className="mt-12">
                <Button asChild variant="secondary" className="rounded-none px-10 py-7 text-base font-bold tracking-wider uppercase shadow-none transition-transform duration-200 active:scale-95 w-full md:w-auto">
                  <Link to={service.link}>Book Service</Link>
                </Button>
              </div>
            </div>)}
        </div>

        <div className="mt-20 text-center">
          <p className="text-muted-foreground mb-8">
            Need a custom solution for your space?
          </p>
          <Button asChild variant="outline" className="rounded-none border-primary text-primary hover:bg-primary hover:text-primary-foreground px-12 py-6 font-bold tracking-widest uppercase">
            <Link to="/ContactPage">Contact Us Directly</Link>
          </Button>
        </div>
      </div>
    </section>;
}